import { createReducer } from '@reduxjs/toolkit'
import { IFree } from 'shared/types'
import { receiveFrees } from 'src/model/actions'

const initialState = null as Record<string, IFree> | null

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveFrees, (state, action) => action.payload)
})

export default reducer
